module.exports = __webpack_public_path__ + "static/media/peixe-solidario.4208a4e6.svg";